/**
 * Normalizes the G360 mainFilterApi response to match the D360
 * getAllDeptDivisionAndApplication response structure.
 *
 * G360 uses: departmentName, divisionName, cspList[].applications[]
 * D360 uses: businessDepartment, businessDivision, applications[]
 */
export const normalizeMainFilterResponse = (data) => {
  if (!Array.isArray(data)) return [];
  return data.map((dept) => ({
    departmentId: null,
    businessDepartment: dept.departmentName,
    divisions: (dept.divisions || []).map((div) => ({
      divisionId: null,
      businessDivision: div.divisionName,
      applications: (div.cspList || []).flatMap((csp) =>
        (csp.applications || []).map((app) => ({
          appName: app.appName,
          appCode: app.appCode,
          environment: app.environments || null,
          subscriptionNames: null,
          id: null,
          pluginFamilies: app.pluginFamilies || null,
        }))
      ),
    })),
  }));
};

export const getActiveDateAppCodes = (selectedFilters, DepartmentDivisionOption) => {
  const { selectedApplication, selectedDepartment, selectedDivision } = selectedFilters;

  if (selectedApplication.length > 0) {
    return selectedApplication;
  }

  const selectedDepartmentValues = selectedDepartment.map((item) => item.value);
  const selectedDivisionValues = selectedDivision.map((item) => item.value);

  const formatApplications = (apps) =>
    apps.map((app) => ({
      label: app.appName,
      value: app.appCode,
    }));

  if (selectedDivisionValues.length > 0) {
    return DepartmentDivisionOption.flatMap((dept) =>
      dept.divisions
        .filter((div) => selectedDivisionValues.includes(div.businessDivision))
        .flatMap((div) => formatApplications(div.applications))
    );
  }
  if (selectedDepartmentValues.length > 0) {
    return DepartmentDivisionOption
      .filter((dept) => selectedDepartmentValues.includes(dept.businessDepartment))
      .flatMap((dept) =>
        dept.divisions.flatMap((div) =>
          formatApplications(div.applications)
        )
      );
  }

  return [];
};


